import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { CategoriesComponent } from '@src/app/features/categories/categories/categories.component';
import { AddCategoryComponent } from '@src/app/features/categories/add-category/add-category.component';
import { ViewCategoryComponent } from '@app/features/categories/view-category/view-category.component';
import { EditCategoryComponent } from '@src/app/features/categories/edit-category/edit-category.component';

const routes: Routes = [
  { path: '', component: CategoriesComponent },
  { path: 'add', component: AddCategoryComponent },
  { path: ':categoryId/edit', component: EditCategoryComponent },
  { path: ':categoryId', component: ViewCategoryComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CategoryRoutingModule { }
